import {
  Component,
  ElementRef,
  Renderer2,
  ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';
import {SubArrangementNodeComponent} from '../sub-arrangement-node/sub-arrangement-node.component';
import {DetailScreensService} from '../detail-screens-module/services/detail-screens-service';
import {DomService} from '../../../services/dom-service/dom.service';
import {ProductOverviewService} from '../../../services/product-overview/product-overview.service';
import {ArrangementLevelComponent} from '../abstract-classes/arrangement-level/arrangement-level.component';
import {ToasterService} from '../../../toaster-module/toaster-service/toaster.service';
import {PopupService} from '../popup-component/popup.service/popup.service';
import {UiHelperService} from '../../../services/shared/helpers/ui-helper.service';

@Component({
  selector: 'app-arrangement-node',
  templateUrl: '../abstract-classes/arrangement-level/arrangement-level.component.html',
  styleUrls: ['../abstract-classes/po-node/ponode.component.css'],
})

export class ArrangementNodeComponent extends ArrangementLevelComponent {
  nodeType = 'arrangement-node';
  componentURL: string | null = null;

  constructor(domService: DomService, private productOverviewService: ProductOverviewService,
              private el: ElementRef, private renderer: Renderer2, private changeRef: ChangeDetectorRef,
              detailsScreenService: DetailScreensService, toasterService: ToasterService, popupService: PopupService,
              protected uiHelper: UiHelperService, private router: Router) {
    super(domService, detailsScreenService, toasterService, popupService, uiHelper);
  }

  ngOnInit() {
    const qp = this.router.routerState.snapshot.root.queryParamMap;
    this.componentURL = qp.get('componentURL');
    this.data.count = '';
  }

  onClick() {
    super.onClick();
    if (this.hierarchyChildren.length === 0 && this.childrenInitialized === false) {
      this.getAndInitializeChildren();
    }
  }

  expand() {
    if (this.expandable) {
      super.expand();
      if (this.hierarchyChildren.length === 0 && this.childrenInitialized === false) {
        this.getAndInitializeAndOpenChildren();
      }
    }
  }

  private getAndInitializeAndOpenChildren() {
    this.productOverviewService.getArrangements(
      this.data.arrangementNumber,
      this.data.administrationCode,
      this
    ).subscribe((resp) => {
      if (Array.isArray(resp) && resp.length > 0) {
        const numberOfChildren = resp.length;
        resp[numberOfChildren - 1].isLastChild = true;

        resp.forEach((child) => {
          this.children.push(this.createComponent(child, SubArrangementNodeComponent));
          this.changeRef.detectChanges();
        });

        this.children.forEach((child) => {
          child.expand();
        });
      }
    });

    this.childrenInitialized = true;
  }

  private getAndInitializeChildren() {
    this.productOverviewService.getArrangements(
      this.data.arrangementNumber,
      this.data.administrationCode,
      this
    ).subscribe((resp) => {
      if (Array.isArray(resp) && resp.length > 0) {
        resp[resp.length - 1].isLastChild = true;

        resp.forEach((child) => {
          this.children.push(this.createComponent(child, SubArrangementNodeComponent));
          this.changeRef.detectChanges();
        });
      }

      this.childrenInitialized = true;
      this.changeRef.detectChanges();
    });
  }

  getArrangementUrl() {
    this.productOverviewService.getArrangementUrl(this.data.arrangementNumber, this.data.administrationCode,
      this.data.bankCode)
      .subscribe(
        (resp) => {
          this.data.arrangementUrl = resp['url'];
          if (this.componentURL?.includes('agentcockpit')) {
            window.open(this.data.arrangementUrl, 'SIEBEL');
           } else {
             window.top.location.href = this.data.arrangementUrl;
           }
        },
        (error) => {
          this.toasterService.startErrorToast([error.error.errorMessage], '', true);
        });
  }
}
